import { Button, ButtonGroup, FormGroup, HTMLTable } from "@blueprintjs/core";
import LabelUtil from "core/components/label/LabelUtil";
import { IFieldProps } from "decorator-form";
import React from "react";
import ArrayItemToolbar from "../common/ArrayItemToolbar";
import TextWidget from "../widgets/TextWidget";

// this totally useless other than for intel TMS thing
export interface IKeyValuePair {
	key: string;
	value: string | IKeyValuePair[];
}

export function KeyValueListField(props: IFieldProps<IKeyValuePair[]> & { depth?: number; allowArrays?: boolean; }) {

	const { depth = 0 } = props;

	const widget = (
		<HTMLTable style={{width: '100%'}}>
			<thead>
				<tr>
					<td>Key</td>
					<td>Value</td>
					<td></td>
				</tr>
			</thead>
			<tbody>
				{
					props.formData && props.formData.length > 0 && props.formData.reduce((arr, p, i) => {

						arr.push(
							<tr key={depth + '-' + i}>
								<td>
									<TextWidget
										value={p.key}
										placeholder="Key"
										onChange={
											(key) => {
												props.onChange(props.formData.map((o, i1) => i1 === i ? {...p, key} : o));
											}
										}
									/>
								</td>
								<td>
									{
										typeof p.value === 'string' && (
											<TextWidget
												value= {p.value}
												placeholder="Value"
												onChange={
													(value) => {
														props.onChange(props.formData.map((o, i1) => i1 === i ? {...p, value} : o));
													}
												}
											/>
										)
									}
								</td>
								<td>
									<ArrayItemToolbar arr={props.formData} onChange={props.onChange} itemIndex={i} />
								</td>
							</tr>
						);

						if (Array.isArray(p.value)) {
							arr.push(
								<tr key={i + '.p'} style={{backgroundColor: 'rgba(0,0,0,0.2)'}}>
									<td colSpan={3} style={{padding: 15}}>
										<KeyValueListField
											{...props}
											depth={depth + 1}
											formData={p.value}
											onChange={(value) => {
												props.onChange(props.formData.map((o, i1) => i1 === i ? {...p, value} : o));
											}}
										/>
									</td>
								</tr>
							);
						}

						return arr;

					}, [])
				}
				<tr>
					<td colSpan={3} style={{textAlign: 'center'}}>
						<ButtonGroup>
							<Button
								small={true}
								text="Add Field"
								icon="small-plus"
								onClick={() => props.onChange([...props.formData || [], {key: "", value: ""}])}
							/>
							{
								depth === 0 && props.allowArrays !== false && (
									<Button
										small={true}
										text="Add JSON Property Group"
										icon="code-block"
										onClick={() => props.onChange([
											...props.formData || [],
											{key: "", value: []}
										])}
									/>
								)
							}
						</ButtonGroup>
					</td>
				</tr>
			</tbody>
		</HTMLTable>
	);

	if (depth < 1) {
		return (
			<FormGroup label={props.schema && props.schema.title} helperText={props.schema && props.schema.description}>
				{widget}
			</FormGroup>
		);
	}

	return widget;
}

export function toAttributesObject(attrs: IKeyValuePair[], data: any = {}, depth: number = 0) {
	return (attrs || []).reduce((o, a) => {

		if (a.key) {

			const key = depth === 0 ? 'data-' + a.key : a.key;

			if (Array.isArray(a.value) && a.value.length) {
				o[key] = JSON.stringify(toAttributesObject(a.value, data, depth + 1));
			}

			if (typeof a.value === 'string') {
				o[key] = data ? LabelUtil.formatTemplate(a.value, data) : a.value;
			}
		}

		return o;
	}, {});
}



// WEBPACK FOOTER //
// ./src/common/form/fields/KeyValueListField.tsx